<template>
  <div class="faults">
    <div class="filters">
      <Dropdown v-model="selectedStatus" :options="statusList" />
      <span class="p-input-icon-left">
        <i class="pi pi-filter" />
        <InputText type="text" v-model="filterText" placeholder="Filter" />
      </span>
    </div>
    <div class="fault_list">
      <div class="fault" v-for="f in filteredFaults" :key="f.id">
        <div class="p-d-flex p-jc-center">
          <div class="p-px-3">
            <h3 class="p-m-2">{{ f.admin }}</h3>
          </div>

          <div class="techstatus p-px-3">
            <h3 class="p-m-2">{{ f.techstatus }}</h3>
          </div>
        </div>

        <div class="desc">
          <h3 class="p-text-uppercase p-m-0">{{ f.desc }}</h3>
        </div>

        <div class="created item">
          <div>Date Reported:</div>
          <b>{{ formatDate(f.created) }}</b>
        </div>

        <div class="user item">
          <div>Operator:</div>
          <b v-if="f.user"
            >{{ f.user.rank }} {{ f.user.lastname }}, {{ f.user.firstname }}
          </b>
          <b v-else>Not assigned</b>
        </div>

        <div class="mechanic item">
          <div>Mechanic Assigned:</div>
          <b v-if="f.mechanic"
            >{{ f.mechanic.rank }} {{ f.mechanic.lastname }},
            {{ f.mechanic.firstname }}
          </b>
          <b v-else class="assigned item">Not assigned</b>
        </div>

        <div class="status item">
          <div>Status:</div>
          <b class="assigned item">{{ f.status || "..." }}</b>
        </div>

        <div class="repairstatus item p-mb-3">
          <div>Status of Repair:</div>
          <b class="assigned item">{{ f.repairstatus || "..." }}</b>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fs, fb_auth, } from "../firebase";
import { format } from "date-fns";
import Dropdown from "primevue/dropdown";

export default {
  name: "NewFaults",
  components: {
    // Dialog,
    Dropdown,
  },
  data() {
    return {
      faults: [],
      confirmRemoveDialog: false,
      filterText: "",
      selectedStatus: "All",
      statusList: ["All", "Not Assigned", "Assigned", "Verified", "Needs Entered In GCSS", "Complete"],
      repairStatusList: [
        "All",
        "In Process",
        "Parts Required",
        "Additonal Time",
        "Repairs Complete",
        "Could Not Validate",
      ],
      options: [
        {
          name: "Not Assigned",
          code: 1,
        },
        {
          name: "Assigned",
          code: 2,
        },
        {
          name: "Verified",
          code: 3,
        },
        {
          name: "All",
          code: 4,
        },
      ],
    };
  },
  async mounted() {
    await this.getFaults();
  },
  methods: {
    async getFaults() {
          let now = new Date();
          now.setDate(now.getDate()-7);
      this.loading = true;
      let userRef = await fb_db.collection("users").doc(fb_auth.currentUser.uid).get()
      let user = userRef.data()
      await fb_db
        .collection("faults").orderBy("created").where("puic", "==", user.puic)
        .where("created",">",now)
        .get()
        .then((docs) => {
          this.faults = [];
          docs.forEach(async (doc) => {
            let item = doc.data();
            item.id = doc.id;
            let user = await item.user.get();
            item.user = user.data();
            if (item.mechanic) {
              console.debug("loading mech");
              let mech = await item.mechanic.get();
              item.mechanic = mech.data();
            }
            this.faults.push(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },
    confirmRemove(faults) {
      console.log("confirm remove");
      this.confirmRemoveDialog = true;
      this.removethisfault = faults;
    },
    deleteFault() {
      console.log("Remove fault: ", this.removethisfault);
      fb_db
        .collection("faults")
        .doc(this.removethisfault.id)
        .delete()
        .then(() => {
          this.removethisfault = null;
          this.getFaults();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:mm MM/DD/YYYY");
    },
  },
  computed: {
    filteredFaults() {
      return this.faults.filter((f) => {
        if (this.selectedStatus == "All") {
          return (
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Not Assigned") {
          return (
            f.status == "Not Assigned" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Assigned") {
          return (
            f.status == "Assigned" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Verified") {
          return (
            f.status == "Verified" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Needs Entered In GCSS") {
          return (
            f.status == "Needs Entered In GCSS" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Complete") {
          return (
            f.status == "Complete" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.faults {
  .fault_list {
    .fault {
      width: 300px;

      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }

      .edit {
        background: $accent;
        // color: $text;
        cursor: pointer;
      }

      .delete {
        background: $primary;
        // color: $white;
        cursor: pointer;
      }

      .item {
        padding: 5px;
        text-align: left;

        b {
          margin-left: 25px;
        }

        div {
          font-size: 14px;
        }
      }

      .admin {
      }

      .techstatus {
        color: red;
        font-size: 25px;
      }

      .desc {
        color: #000000;
      }

      .verify {
      }

      .repairstatus {

      }

      .created {
      }

      .mechanic {
        color: black;
      }

      .assigned {
        color: #FFCC5C;
      }
    }
  }
}
</style>